import { apiPost } from "./api-client";

export function getPromoteInfo() {
  // 团队概览：POST /api/user/team（无参数）
  return apiPost("/api/user/team", {});
}

export function getRebates({ page = 1, limit = 10, level = 0 } = {}) {
  // 下级返佣记录：POST /api/user/team_record { page, limit, level }
  // level: 0=全部 1/2/3=层级
  return apiPost("/api/user/team_record", { page, limit, level });
}
